module.exports = __webpack_public_path__ + "static/media/certificate5.e3f77c7e.webp";